import React from 'react'

const Footer = () => {
    return (
        <div>
            
            <hr></hr>
            <p className="footer-text">Improvised By Priya Kumari Gupta<br></br>
            <br></br>
            
            <small>All rights reserved © 2021 Tejaswi Chaudhari</small><br></br>
            <small>Illustrations by undraw.co</small>
            </p>
        </div>
    )
}

export default Footer
